import { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'
import { TileSize as TileSizeType } from './types/tileSize'

export type TileSize = TileSizeType

export interface TileProps {
  children?: ReactNode
  onClick?: () => void
  size?: TileSizeType
}

export const Tile = ({ children, onClick, size }: TileProps): ReactElement => {
  const isClickable = typeof onClick === 'function'
  const tag = isClickable ? 'button' : 'div'

  return (
    <Styled.TileWrapper
      as={tag}
      size={size}
      isClickable={isClickable}
      onClick={onClick}
      data-testid="tile"
      {...(isClickable ? { type: 'button' } : {})}
    >
      {children}
    </Styled.TileWrapper>
  )
}
